import React from 'react';
import CTABG from './assests/CTABG.png';
import TwoDots from "./assests/TwoDots.svg"

const HeroSection = () => {
  return (
    <div
      className="w-[100vw] border-l-[2px] border-white h-[400px] relative overflow-hidden mx-[-25px] overflow-x-hidden"
      style={{
        backgroundImage: `url(${CTABG})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >

      
      {/* Main content container */}
      <div className="flex items-center justify-center h-full px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto"
            style={{ fontFamily: 'Manrope, sans-serif' }}
        >
          {/* Main heading */}
          <h1 className="font-manrope font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-8"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            Master Your Brand's Every{' '}
            <span className="block">Conversation</span>
          </h1>
          
          {/* CTA Button */}
          <button className="inline-flex items-center px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            <span className="mr-2">TALK TO US</span>
            <img src={TwoDots} alt="Two Dots" className="w-2 h-2" />
          </button>
        </div>
      </div>
      
      {/* Optional: Background pattern/texture */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent transform -skew-y-12"></div>
      </div>
    </div>
  );
};

export default HeroSection;